<template>
  <section class="proyecto-panel">
    <div v-if="error" class="mod-alert-error">
      <i class="bi bi-exclamation-triangle-fill"></i>
      {{ error }}
    </div>

    <div class="proyecto-contact-card">
      <div class="proyecto-contact-form">
        <div class="mod-field proyecto-contact-persona">
          <label>Persona contacto <span class="mod-required">*</span></label>
          <CatSearch
            catalogo="persona_contacto"
            v-model="form.PersonaContactoClave"
            placeholder="Buscar persona..."
            display-field="nombre"
          />
        </div>
        <div class="mod-field proyecto-contact-rol">
          <label>Rol en proyecto</label>
          <CatSearch
            catalogo="proyecto_contacto_rol"
            v-model="form.RolProyecto"
            placeholder="Buscar rol..."
            display-field="nombre"
            :min-length="0"
          />
        </div>
        <div class="mod-field proyecto-contact-orden">
          <label>Orden</label>
          <input v-model.number="form.Orden" type="number" min="0">
        </div>
        <div class="mod-field mod-field-check proyecto-contact-principal">
          <label class="mod-check-label">
            <input v-model="form.EsPrincipal" type="checkbox">
            <span>Principal</span>
          </label>
        </div>
        <div class="mod-field proyecto-contact-notas">
          <label>Notas</label>
          <input v-model="form.Notas" type="text" placeholder="Notas del contacto dentro del proyecto">
        </div>
        <div class="proyecto-panel-actions">
          <button type="button" class="mod-btn mod-btn-cancel" @click="limpiar">Limpiar</button>
          <button type="button" class="mod-btn mod-btn-save" :disabled="saving" @click="guardar">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ form.ProyectoPersonaContactoId ? 'Actualizar' : 'Agregar' }}
            </template>
          </button>
        </div>
      </div>
    </div>

    <div class="proyecto-table-wrap">
      <div v-if="loading" class="proyecto-empty">Cargando contactos...</div>
      <div v-else-if="items.length === 0" class="proyecto-empty">Sin contactos ligados al proyecto</div>
      <table v-else class="proyecto-table">
        <thead>
          <tr>
            <th>Contacto</th>
            <th>Rol</th>
            <th>Empresa</th>
            <th>Telefono</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.ProyectoPersonaContactoId">
            <td>
              <strong>{{ item.NombreSnapshot || item.PersonaContactoClave }}</strong>
              <span v-if="item.EsPrincipal" class="proyecto-badge">Principal</span>
            </td>
            <td>{{ item.RolProyecto || '-' }}</td>
            <td>{{ item.EmpresaNombreSnapshot || '-' }}</td>
            <td>{{ item.TelefonoSnapshot || '-' }}</td>
            <td>{{ item.EmailSnapshot || '-' }}</td>
            <td class="proyecto-row-actions">
              <button type="button" class="proyecto-icon-btn" title="Editar" @click="editar(item)">
                <i class="bi bi-pencil"></i>
              </button>
              <button type="button" class="proyecto-icon-btn danger" title="Quitar" @click="borrar(item)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import CatSearch from '@/shared/components/CatSearch.vue';
import { showToast } from '@/shared/utils/toast';
import proyectoGestionService from './proyectoGestion.service';

const nuevo = proyectoClave => ({
  ProyectoPersonaContactoId: 0,
  ProyectoClave: proyectoClave,
  PersonaContactoClave: '',
  RolProyecto: '',
  EsPrincipal: false,
  Orden: 0,
  Notas: ''
});

export default {
  name: 'ProyectoContactosPanel',
  components: { CatSearch },
  props: {
    proyectoClave: { type: String, required: true }
  },
  data() {
    return {
      form: nuevo(this.proyectoClave),
      items: [],
      loading: false,
      saving: false,
      error: null
    };
  },
  created() {
    this.cargar();
  },
  methods: {
    async cargar() {
      this.loading = true;
      try {
        this.items = await proyectoGestionService.listarContactos(this.proyectoClave);
      } catch {
        this.error = 'No fue posible cargar contactos';
      } finally {
        this.loading = false;
      }
    },
    limpiar() {
      this.form = nuevo(this.proyectoClave);
      this.error = null;
    },
    editar(item) {
      this.form = { ...item };
    },
    async guardar() {
      if (!this.form.PersonaContactoClave) {
        this.error = 'Selecciona una persona contacto';
        return;
      }
      this.saving = true;
      this.error = null;
      try {
        const result = await proyectoGestionService.guardarContacto({
          ...this.form,
          ProyectoClave: this.proyectoClave
        });
        if (result.Number >= 0) {
          showToast(result.Message || 'Contacto guardado', result.Type || 'success');
          this.limpiar();
          await this.cargar();
        } else {
          this.error = result.Message || 'Error al guardar contacto';
        }
      } catch {
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    },
    async borrar(item) {
      if (!confirm('Quitar este contacto del proyecto?')) return;
      try {
        const result = await proyectoGestionService.borrarContacto(item);
        if (result.Number >= 0) {
          showToast(result.Message || 'Contacto quitado', result.Type || 'success');
          await this.cargar();
        } else {
          this.error = result.Message || 'Error al quitar contacto';
        }
      } catch {
        this.error = 'Error de conexion con el servidor';
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
@import "./proyectoGestionPanels.css";
</style>
